(function () {
    const wrapper = document.querySelector('.learn-more-dropBlock');
    if (wrapper) {
        const learnMoreModalTrigger = wrapper.querySelector('[data-db-target-for="learnMorePopup"]');
        const learnMoreModal = wrapper.querySelector('#learnMorePopup');
        const learnMoreModalDismissSelectors = ['.learnMorePopup-container', '.close'];
        const onCloseModal = e => {
            learnMoreModalTrigger.click();
        };

        //Close the modal if the user clicks on one of these elements
        learnMoreModalDismissSelectors.forEach(s => {
            const el = wrapper.querySelector(s);
            el?.addEventListener('click', onCloseModal);
        });

        learnMoreModal?.addEventListener('click', e => {
            e.stopPropagation();
        });
    }
})();
